import Icon from "@/components/Icon";
import { IconProps } from "@/components/Icon/Icon";
import RawChevronDownIcon from "./RawChevronDownIcon.svg.jsx";

const ChevronDownIcon = ({
  strokeWidth = "2px",
  ref,
  ...props
}: Omit<IconProps, "SvgComponent">) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawChevronDownIcon}
      strokeWidth={strokeWidth}
      {...props}
    />
  );
};

export default ChevronDownIcon;
